<template>
	<form method="post" :action="formAction">
        <input name="_token" type="hidden" :value="csrfToken">
        <div class="row row-cards"> 
            <div class="col-12 col-md-12 col-lg-12">
                <div class="row row-cards"> 
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">Category</h3>
                            </div>
                            <div class="card-body">
                                <fieldset class="form-fieldset">
                                    <div class="form-group mb-3">
                                        <label class="form-label required" for="name">Name</label>
                                        <input type="text" name="name" v-model="category.name" class="form-control" id="name" value="" placeholder="Enter Name">
                                    </div>
                                    <div class="form-group mb-3">
                                        <label class="form-label" for="name">Overview</label>
                                        <textarea class="form-control" v-model="category.desc" name="desc" rows="6" placeholder="Description..."></textarea>
                                    </div>
                                    <div class="form-group mb-3">
                                        <label class="form-label" for="name">Status</label>
                                        <select class="form-select" name="is_active" v-model="category.is_active">
                                            <option v-for="(a, index) in is_active" :key="index" :value="a.id">{{ a.name }}</option>
                                        </select>  
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-12 col-lg-12">
                <div class="row row-cards"> 
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">Sub Category & Topics</h3>
                            </div>
                            <div class="card-body">

                                <div v-for="(sub, index) in subs" :key="'A_'+sub.id" style="margin-bottom: 1rem;">
                                    <fieldset class="form-fieldset" style="border: 2px dashed #e6e8e9;">

                                        <div class="row align-items-center">
                                            <div class="col-auto ms-auto d-print-none">
                                                <div class="d-flex">
                                                    <button type="button" class="btn btn-danger" v-on:click="removeRow(index, sub.hashslug)">
                                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="4" y1="7" x2="20" y2="7" /><line x1="10" y1="11" x2="10" y2="17" /><line x1="14" y1="11" x2="14" y2="17" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>
                                                        Delete Sub Category
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group mb-3">
                                            <div class="row">
                                                <div class="col-6">
                                                    <label class="form-label">#{{ index + 1 }} Sub Category Name</label>
                                                    <input type="text" v-model="sub.name" :name="'sub_name['+index+']'" class="form-control" value="" placeholder="Enter Name">
                                                    <input type="hidden" :name="'sub_hashslug['+index+']'" :value="sub.hashslug">
                                                </div>
                                                <div class="col-6">
                                                    <label class="form-label">Sub Category Overview</label>
                                                    <div class="input-group">                                               
                                                        <input type="text" v-model="sub.desc" :name="'sub_desc['+index+']'" class="form-control" value="" placeholder="Enter Description">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <fieldset class="form-fieldset" v-for="(topic, indexTopic) in sub.topics" :key="'B_'+topic.id">
                                            <div class="mb-3">
                                                <div class="row">
                                                    <div class="col-6">
                                                        <label class="form-label">Topic Name</label>
                                                        <input type="text" v-model="topic.name" :name="'topic_name['+index+']['+indexTopic+']'" class="form-control" value="" placeholder="Enter Name">
                                                        <input type="hidden" :name="'topic_hashslug['+index+']['+indexTopic+']'" :value="topic.hashslug">
                                                    </div>
                                                    <div class="col-6">
                                                        <label class="form-label">Topic Overview</label>
                                                        <input type="text" v-model="topic.desc" :name="'topic_desc['+index+']['+indexTopic+']'" class="form-control" value="" placeholder="Enter Description">
                                                    </div>
                                                </div>
                                            </div>

                                            <fieldset class="form-fieldset" v-for="(subtopic, indexSubTopic) in topic.sub_topics" :key="'C_'+subtopic.id">
                                                <div class="form-group mb-3">
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <label class="form-label">Sub Topic Name</label>
                                                            <input type="text" v-model="subtopic.name" :name="'sub_topic_name['+index+']['+indexTopic+']['+indexSubTopic+']'" class="form-control" value="" placeholder="Enter Name">
                                                            <input type="hidden" :name="'sub_topic_hashslug['+index+']['+indexTopic+']['+indexSubTopic+']'" :value="subtopic.hashslug">
                                                        </div>
                                                        <div class="col-6">
                                                            <label class="form-label">Sub Topic Overview</label>
                                                            <div class="input-group">
                                                                <input type="text" v-model="subtopic.desc" :name="'sub_topic_desc['+index+']['+indexTopic+']['+indexSubTopic+']'" class="form-control" value="" placeholder="Enter Description">
                                                                <button type="button" class="btn btn-icon btn-danger" title="Remove Row" v-on:click="removeRowSubTopic(index, indexTopic, indexSubTopic, subtopic.hashslug)">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><circle cx="12" cy="12" r="9" /><line x1="9" y1="12" x2="15" y2="12" /></svg>
                                                                </button>    
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <div class="row align-items-center">
                                                <div class="col">
                                                    <button type="button" class="btn btn-info" v-on:click="addRowSubTopic(index, indexTopic)">
                                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M14 3v4a1 1 0 0 0 1 1h4" /><path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" /><line x1="12" y1="11" x2="12" y2="17" /><line x1="9" y1="14" x2="15" y2="14" /></svg>
                                                        Add Sub Topic
                                                    </button>
                                                </div>

                                                <div class="col-auto ms-auto d-print-none">
                                                    <div class="d-flex">
                                                        <button type="button" class="btn btn-danger" v-on:click="removeRowTopic(index, indexTopic, topic.hashslug)">
                                                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="4" y1="7" x2="20" y2="7" /><line x1="10" y1="11" x2="10" y2="17" /><line x1="14" y1="11" x2="14" y2="17" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>
                                                            Delete Topic
                                                        </button>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </fieldset>

                                        <div class="row align-items-center">
                                            <div class="col">
                                                <button type="button" class="btn btn-purple" v-on:click="addRowTopic(index)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0" /><path d="M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0" /><line x1="3" y1="6" x2="3" y2="19" /><line x1="12" y1="6" x2="12" y2="19" /><line x1="21" y1="6" x2="21" y2="19" /></svg>
                                                    Add Topic
                                                </button>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>

                                <div class="row align-items-center">
                                    <div class="col">
                                        <div class="form-group mb-3">
                                            <button type="button" class="btn btn-primary" v-on:click="addRow">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
                                                Add Sub Category
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-auto ms-auto d-print-none">
                                        <div class="d-flex">
                                            <button type="submit" class="btn btn-success" :disabled="disabledButtonSave">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2" /><circle cx="12" cy="14" r="2" /><polyline points="14 4 14 8 8 8 8 4" /></svg>
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <input type="hidden" v-model="sub_category_del" name="sub_category_del">
        <input type="hidden" v-model="topic_del" name="topic_del">
        <input type="hidden" v-model="sub_topic_del" name="sub_topic_del">
    </form>
</template>


<script>
    export default {
        props: ['data'],        
        data() {
            return {
                csrfToken: "",
                category: [],
                subs: [{
                    id: this.counterSubCategory, name: "", desc: "",
                    topics: [{
                        id: this.counterTopic, name: "", desc: "",
                        sub_topics: [{
                            id: this.counterSubTopic, name: "", desc: "",
                        }],
                    }],
                }],
                counterSubCategory: 0,
                counterTopic: 0,
                counterSubTopic: 0,
                sub_category_del: [],
                topic_del: [],
                sub_topic_del: [],
                is_active: [
                    {id: 1, name: 'Active'},
                    {id: 0, name: 'Inactive'},
                ],
            };
        },        
        mounted() {
            this.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
            this.getCategory();
        },
        methods: {
            getCategory() {
                axios.get('/api/ajax/mod/categories/hashslug/' + this.data.hashslug).then(res => {
                    this.category = res.data.data;
                    if (res.data.data.sub_categories) {
                        this.subs = res.data.data.sub_categories;
                        this.counterTopic += 1;
                        this.counterSubTopic += 1;
                    }
                });
            },
            addRow() {
                this.counterSubCategory += 1;
                this.subs.push({
                    id: this.counterSubCategory, name: "", desc: "",
                    topics: [{
                        id: this.counterTopic, name: "", desc: "",
                        sub_topics: [{
                            id: this.counterSubTopic, name: "", desc: "",
                        }],
                    }],
                });
            },
            removeRow(index, hashslug) {
                if (hashslug) {
                    this.sub_category_del.push(hashslug);
                }
                this.subs.splice(index, 1);
            },
            addRowTopic(index) {
                this.counterTopic += 1;
                this.counterSubTopic += 1;
                this.subs[index].topics.push({
                    id: this.counterTopic, name: "", desc: "",
                    sub_topics: [{
                        id: this.counterSubTopic, name: "", desc: "",
                    }],
                });
            },
            removeRowTopic(index, indexTopic, hashslug) {
                if (hashslug) {
                    this.topic_del.push(hashslug);                
                }
                this.subs[index].topics.splice(indexTopic, 1);
            },
            addRowSubTopic(index, indexTopic) {
                this.counterTopic += 1;
                this.counterSubTopic += 1;
                this.subs[index].topics[indexTopic].sub_topics.push({
                    id: this.counterSubTopic, name: "", desc: "",
                });
            },
            removeRowSubTopic(index, indexTopic, indexSubTopic, hashslug) {
                if (hashslug) {
                    this.sub_topic_del.push(hashslug);                                
                }
                this.subs[index].topics[indexTopic].sub_topics.splice(indexSubTopic, 1);             
            },  
        },
        computed: {
            disabledButtonSave() {
                if (!this.category.name) {
                    return true;
                }
            },
            formAction: function() {
                return '/module/category/' + this.data.hashslug + '/edit';
            }, 
        },   

    }
</script>


